import createCachedSelector from 're-reselect';
import { IGlobalReduxStore } from 'store';

const getSchedule = (state: IGlobalReduxStore) => state.schedule;

export const selectedScheduleFacilityIdSelector = createCachedSelector(getSchedule, (schedule) => {
  const value = Number.parseInt(String(schedule.selectedFacilityId));
  if (value == null) return value;
  if (typeof value !== 'number')
    throw new Error('selectedScheduleFacilityIdSelector must return an integer.');
  return value;
})(({ schedule }) => `${schedule.selectedFacilityId || 'null'}`);
